export default "__VITE_ASSET__BR8QLt3i__"